/**
 * Toast Container
 * Renders toast notifications in a fixed position overlay.
 */

import { Toast, type ToastProps } from './Toast';
import styles from './ToastContainer.module.css';

export interface ToastContainerProps {
  toasts: Omit<ToastProps, 'onDismiss'>[];
  onDismiss: (id: string) => void;
  position?: 'top-right' | 'top-center' | 'bottom-right' | 'bottom-center';
}

export function ToastContainer({ toasts, onDismiss, position = 'top-right' }: ToastContainerProps) {
  if (toasts.length === 0) {
    return null;
  }

  return (
    <div className={`${styles.container} ${styles[position]}`} aria-live="polite">
      {toasts.map((toast) => (
        <Toast key={toast.id} {...toast} onDismiss={onDismiss} />
      ))}
    </div>
  );
}
